<script lang="ts">
    import { theme } from '$theme/theme.svelte';
    import Text from '$components/common/text/text.svelte';
    import LowerDots from '$assets/icons/nav-guidance-divider/lower-dots.svelte';
    import UpperDots from '$assets/icons/nav-guidance-divider/upper-dots.svelte';
    export let lower = false;
    export let upper = false;
    export let solidToFade = false;

    export let includeChip = true;
</script>

{#if upper}
    <div class="nav-guidance-divider-container">
        <UpperDots
            width={$theme.viewportWidth > 768 ? 28 : 21}
            height={$theme.viewportWidth > 768 ? 63 : 47}
            class={solidToFade ? 'solid-to-fade' : ''}
        />
    </div>
{/if}
{#if lower}
    <div class="nav-guidance-divider-container">
        <LowerDots
            width={$theme.viewportWidth > 768 ? 28 : 21}
            height={$theme.viewportWidth > 768 ? 100 : 75}
        />
        {#if includeChip}
            <div class="chip center">
                <Text variant="bodyMedium" color={$theme.colors.secondary[900]}>
                    <slot />
                </Text>
            </div>
        {/if}
    </div>
{/if}

<style>
    .nav-guidance-divider-container :global(.solid-to-fade) {
        transform: rotate(180deg);
    }

    .nav-guidance-divider-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        padding-bottom: var(--spacing-01);
    }

    .chip {
        background-color: var(--colors-secondary-50);
        padding: var(--spacing-05) var(--spacing-16);
        border-radius: var(--spacing-11);
        margin-top: var(--spacing-12);
        margin-bottom: var(--spacing-11);
    }

    @media (min-width: 769px) {
        .chip {
            margin-bottom: var(--spacing-15);
        }
    }
</style>
